import React, { useState, useRef, useEffect } from 'react';
import '../styles/Amenities.scss';

// imports...
import cctv from '../assets/amenities/cctv.jpg';
import chainlink from '../assets/amenities/Barbed_Fencing.jpg';
import clubhouse from '../assets/amenities/clubhouse.jpg';
import demarcatedplots from '../assets/amenities/demarcatedplots.jpg';
import enterencegate from '../assets/amenities/enterence-gate.jpeg';
import gatedcommunity from '../assets/amenities/serene-envirn.jpeg';
import light from '../assets/amenities/light.jpg';
import securitycabin from '../assets/amenities/security-cabin.jpg';
import starcommercial from '../assets/amenities/star-commercial.jpeg';
import streetlight from '../assets/amenities/streetlight.jpg';
import water from '../assets/amenities/water.jpg';
import watertank from '../assets/amenities/watertank.jpg';
import road from '../assets/amenities/wide-roads.jpeg';
import nameplate from '../assets/amenities/nameplate.png';
import saledeed from '../assets/amenities/saledeed.jpg';
import walk from '../assets/amenities/walk.jpg';

const items = [
    { title: 'In 4 Acres of  Resort.', content: 'A vast property designed for wellness and business comfort.', image: starcommercial },
    { title: 'Gated Community', content: 'Secure and serene environment.', image: gatedcommunity },
    { title: 'Entrance Gate', content: 'Grand welcome with landscaped entry.', image: enterencegate },
    { title: 'Security Cabin', content: 'Dedicated security post ensuring round-the-clock safety and peace of mind.', image: securitycabin },
    { title: 'CCTV Camera', content: '24/7 surveillance with strategically placed CCTV camera to the Entrance gate.', image: cctv },
    { title: 'Cement Pole with Barbed Wire Fencing Compound', content: 'Well-defined boundary with Cement Pole with Barbed Wire Fencing Compound securing the entire property.', image: chainlink },
    { title: 'Wide Tar Roads', content: '15 meter Project main road. 12 & 9 & 7.5  meter project Internal road.', image: road },
    { title: 'Street Light', content: 'Modern street lighting for safe and pleasant walks, even after sunset.', image: streetlight },
    { title: 'Water Connection', content: 'Reliable and sustainable water supply for every plot and amenity.', image: water },
    { title: 'Overhead Watertank', content: 'Centralized water storage ensuring uninterrupted water availability.', image: watertank },
    { title: 'Distictively Demarcated Plots', content: 'Well-planned plots with clear demarcations for easy ownership.', image: demarcatedplots },
    { title: 'Name Plate', content: 'Personalized name plates for each plot, adding character and identity.', image: nameplate },
    { title: 'Individual SaleDeed & 7/12', content: 'Transparent legal documentation with individual Sale Deeds and 7/12 extracts.', image: saledeed },
    { title: 'Walk in Nature', content: 'Experience the joy of walking through tranquil natural surroundings.', image: walk },
    // { title: 'Clubhouse', content: 'A modern clubhouse designed for recreation, relaxation, and community bonding.', image: clubhouse },
    { title: 'Electricity', content: 'Well-connected electricity supply for every plot and amenity.', image: light },
];

export default function Amenities() {
    const [activeIndex, setActiveIndex] = useState(0);
    const cardRefs = useRef([]);

    // Auto-scroll every 4 seconds
    //   useEffect(() => {
    //     const interval = setInterval(() => {
    //       handleNext();
    //     }, 4000);

    //     return () => clearInterval(interval);
    //   }, [activeIndex]);

    const handleNext = () => {
        const newIndex = (activeIndex + 1) % items.length;
        scrollToCard(newIndex);
    };

    const handlePrev = () => {
        const newIndex = (activeIndex - 1 + items.length) % items.length;
        scrollToCard(newIndex);
    };

    const scrollToCard = (index) => {
        setActiveIndex(index);
        cardRefs.current[index]?.scrollIntoView({
            behavior: 'smooth',
            inline: 'center',
            block: 'nearest',
        });
    };

    return (
        <section id="amenities" className="amenities">
            <div className="container">
                <h2>Lifestyle & Amenities</h2>
                <p className="lead">Luxuries that honour nature — Pure living. Natural luxury.</p>

                <div className="carousel-wrapper">
                    <button className="nav prev" onClick={handlePrev} aria-label="Previous">&#10094;</button>

                    <div className="amen-carousel">
                        {items.map((it, idx) => (
                            <div
                                key={idx}
                                ref={(el) => (cardRefs.current[idx] = el)}
                                className={`amen-card ${activeIndex === idx ? 'active' : ''}`}
                            >
                                <div
                                    className="overlay"
                                    style={{ backgroundImage: `url(${it.image})` }}
                                ></div>
                                <div className="amen-content">
                                    <p>{it.content}</p>
                                    <h3>{it.title}</h3>
                                </div>
                            </div>
                        ))}
                    </div>

                    <button className="nav next" onClick={handleNext} aria-label="Next">&#10095;</button>
                </div>

                <div className="indicators">
                    {items.map((_, idx) => (
                        <span
                            key={idx}
                            className={activeIndex === idx ? 'dot active' : 'dot'}
                            onClick={() => scrollToCard(idx)}
                        ></span>
                    ))}
                </div>
            </div>
        </section>
    );
}
